import { render, staticRenderFns } from "./ContactCustomerService.vue?vue&type=template&id=68508043&scoped=true&"
import script from "./ContactCustomerService.vue?vue&type=script&lang=js&"
export * from "./ContactCustomerService.vue?vue&type=script&lang=js&"
import style0 from "./ContactCustomerService.vue?vue&type=style&index=0&id=68508043&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68508043",
  null
  
)

export default component.exports